<template>
	<div>
		<!-- 搜索 -->
		<div class="search-container">
			<div class="search-form">
				<div class="form-item">
					<span class="label">姓名：</span>
					<el-input v-model="queryParams.personName" placeholder="请输入姓名" clearable></el-input>
				</div>

				<div class="form-buttons">
					<el-button type="primary" @click="handleSearch()">查询</el-button>
					<el-button @click="handleResetSearch()">重置</el-button>
				</div>
			</div>
		</div>

		<data-table
			:table-data="technicalManager"
			:column="personnelColumns"
			:loading="loadingStatus"
			:page-options="pageOptions"
			:border="true"
			:single="true"
			:selection="true"
			:reserve-selection="true"
			:row-keys="handleRowKeys"
			:index="true"
			@selectionChange="handleStaffSelect"
			@page-change="handlePageChange"
		></data-table>
	</div>
</template>

<script>
	import DataTable from '@/components/JrTable/DataTable.vue'
	import { queryGcjlPersonPage } from '@/api/certTreasure/materialRecord'

	// 工程监理对应企业注册人员（监理工程师人员列表）
	export default {
		name: 'SupervisorLibrary',
		components: {
			DataTable
		},
		props: {},
		data() {
			return {
				// 搜索
				queryParams: {
					personName: ''
				},
				// 技术负责人
				technicalManager: [],
				// 列表加载状态
				loadingStatus: false,
				// 表格列配置
				personnelColumns: [
					{ prop: 'personName', label: '姓名' },
					{ prop: 'certificateName', label: '证书类型' },
					{ prop: 'idCard', label: '身份证号' },
					{ prop: 'certificateCode', label: '证书编号' },
					{ prop: 'validityTime', label: '证书有效期' }
				],
				pageOptions: {
					page: 1,
					limit: 10,
					total: 0
				},
				// 所选人员id集合
				staffIdArray: []
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			this.handleQueryEnterpriseTechnical()
		},
		methods: {
			// 查询企业注册监理工程师
			handleQueryEnterpriseTechnical() {
				const params = {
					page: this.pageOptions.page,
					size: this.pageOptions.limit,
					// 71监理工程师 91一级造价工程师 92二级造价工程师
					certificateType: '71,91,92',
					...this.queryParams
				}

				this.loadingStatus = true
				queryGcjlPersonPage(params)
					.then(response => {
						const { data } = response
						if (data.records && data.records.length > 0) {
							this.technicalManager = data.records
							this.pageOptions.total = data.total
							this.loadingStatus = false
						} else {
							this.technicalManager = []
							this.pageOptions.total = 0
							this.loadingStatus = false
						}
					})
					.catch(error => {
						this.technicalManager = []
						this.pageOptions.total = 0
						this.loadingStatus = false
					})
			},

			// 分页
			handlePageChange(pager) {
				this.pageOptions.page = pager.page
				this.pageOptions.limit = pager.limit
				this.handleQueryEnterpriseTechnical()
			},

			// 搜索
			handleSearch() {
				this.pageOptions.page = 1
				this.pageOptions.limit = 10
				this.handleQueryEnterpriseTechnical()
			},

			// 重置搜索
			handleResetSearch() {
				this.queryParams = {
					name: ''
				}
				this.handleQueryEnterpriseTechnical()
			},

			handleRowKeys(row) {
				return row.id
			},

			// 人员库数据选择回调
			handleStaffSelect(selection) {
				// 字段映射配置
				const fieldMapping = [
					'id',
					'personName',
					'certType',
					'sex',
					'idCard',
					'registerType',
					'registerSubType',
					'certificateName',
					'certificateGrade',
					'certificateCode',
					'certificateType',
					'registerCode',
					'registerUnitName',
					'registerUnitCode',
					'registerProject',
					'registerTime',
					'validityTime'
				]

				// 转换数据字段
				this.staffIdArray = selection.map(item => {
					const newItem = {}
					fieldMapping.forEach(field => {
						newItem[field] = item[field]
					})

					return newItem
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.search-container {
		padding: 10px;
		margin-bottom: 20px;

		.search-form {
			display: flex;
			flex-wrap: wrap;
			gap: 20px;

			.form-item {
				display: flex;
				align-items: center;

				.label {
					white-space: nowrap;
					margin-right: 8px;
					color: #606266;
				}

				.el-input {
					width: 200px;
				}

				.el-select {
					width: 200px;
				}

				.el-date-picker {
					width: 400px;
				}
			}
		}
	}
</style>
